var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useRef, useState, useEffect, useContext } from 'react';
import '../styles/scrollbar.scss';
import ToggleButton from './ToggleButton';
import ButtonComponent from './ButtonComponent';
import CollapsibleDiv from './CollapsibleDiv';
import globalStore from '../store';
import { DataContext } from '../player/DataContext';
import SaveBtnWithPopup from './SaveBtnWithPopup';
import ColorPicker from './ColorPicker';
import HalfAndHalfToggleButton from './HalfAndHalfToggleButton';
import { useRovingTabIndex } from '../helper/hooks/useRovingTabIndex';
import { useTranslation } from 'react-i18next';
import { isOwnShareCode } from '../helper/ownShareCodes';
import { isLocalLoginMode } from '../helper/localLoginMode';
import Popup from './Popup';
// Same-origin page both auth flows are redirected to when they finish. It posts
// `{ type: 'sso-login-complete' }` to whichever context opened it — `opener` for
// the login popup, `parent` for the hidden logout iframe — and then closes
// itself if it is a popup. Copied to the site root at build time (see
// webpack.config.js) from public/auth-popup-complete.html.
//
// Passed to /login and /logout as a bare `?redirect=` path — see
// handleLoginPopup for why it must never carry a routing marker.
var AUTH_POPUP_CALLBACK = '/auth-popup-complete.html';
// How long to wait for the callback page to report back before giving up and
// refreshing the auth UI anyway. Only reachable when the flow never returns to
// this origin — an IdP error, a stalled SLO chain, or an IdP that refuses to be
// framed. Nothing is visible while it runs, so this is a correctness backstop,
// not a delay the user sits through.
var AUTH_SETTLE_BACKSTOP_MS = 5000;
var ButtonGroup = function (_a) {
    var _b;
    var align = _a.align, buttonsInfo = _a.buttonsInfo, mainClass = _a.mainClass, type = _a.type, onClick = _a.onClick, _c = _a.isParentRelative, isParentRelative = _c === void 0 ? false : _c, _d = _a.collapsible, collapsible = _d === void 0 ? {
        isTooltipRelative: false,
        isRelative: false,
    } : _d, _e = _a.buttonStyleType, buttonStyleType = _e === void 0 ? 'textType1' : _e, _f = _a.disabledButtons, disabledButtons = _f === void 0 ? [] : _f, _g = _a.hiddenButtons, hiddenButtons = _g === void 0 ? [] : _g, _h = _a.collapsibleGuide, collapsibleGuide = _h === void 0 ? {} : _h, ariaLabel = _a.ariaLabel, externalGetTabIndex = _a.rovingGetTabIndex, externalSetItemRef = _a.rovingSetItemRef, _j = _a.rovingStartIndex, rovingStartIndex = _j === void 0 ? 0 : _j, _k = _a.useViewportPosition, useViewportPosition = _k === void 0 ? false : _k;
    var t = useTranslation().t;
    // const [btnData, setBtnData] = useState<any>(null);
    // const [btnType, setBtnType] = useState<any>(null);
    var _l = useState(null), btnData = _l[0], setBtnData = _l[1];
    var _m = useState(null), btnType = _m[0], setBtnType = _m[1];
    var showEnterKeyModal = useContext(DataContext).showEnterKeyModal;
    var _o = globalStore.useStoreState(function (state) { return state.playerStore; }), language = _o.language, isLoggedIn = _o.isLoggedIn, isIDM = _o.isIDM, shareCode = _o.shareCode, viewEditMode = _o.viewEditMode, masquerade = _o.masquerade;
    var _p = globalStore.useStoreState(function (state) { return state.jsonDataStore; }), btnConfig = _p.btnConfig, mainConfig = _p.mainConfig;
    var _q = globalStore.useStoreActions(function (state) { return state.playerStore; }), checkAuth = _q.checkAuth, setIsLoggedIn = _q.setIsLoggedIn, setUsername = _q.setUsername, setUserId = _q.setUserId, setIsAdmin = _q.setIsAdmin, setMasquerade = _q.setMasquerade;
    var fetchCardDecks = globalStore.useStoreActions(function (state) { return state.jsonDataStore; }).fetchCardDecks;
    var _r = globalStore.useStoreActions(function (state) { return state.groupsStore; }), fetchGroups = _r.fetchGroups, setSections = _r.setSections;
    // Logout is confirmed before it runs — signing out is not undoable from here
    // (the IdP single-logout chain has to be walked again), and the button sits
    // one control away from Save/Share in the header. Login needs no confirmation.
    var _s = useState(false), showLogoutConfirm = _s[0], setShowLogoutConfirm = _s[1];
    // Masquerade indication on the auth button. The notice dialog
    // (MasqueradeNoticeModal) discloses the impersonation once, at load, and is
    // then dismissed for good — after which nothing on screen said the session
    // was not the admin's own. This is the persistent form of that disclosure.
    //
    // Gated on `isLoggedIn` as well as the slice: the button only renders its
    // logout face when signed in, and a stale `masquerade` next to a Login icon
    // would name an account the user is no longer in.
    //
    // Truthiness, NOT `!== null`. The slice is typed `MasqueradeInfo | null`, so
    // the two look equivalent — but any state object that simply omits the key
    // (a partial store, a test mock) yields `undefined`, and `undefined !== null`
    // is true. That would badge an ordinary session as a masquerade and label it
    // with an account name it never had, which is a worse failure than missing
    // the disclosure: it asserts something false about whose session this is.
    var isMasquerading = isLoggedIn && !!masquerade;
    // `viewingAsName` is the name alone — the fuller `viewingAs` carries the
    // email too, which the notice dialog wants and a header tooltip does not.
    // It is null only when the payload identifies the account in no way at all;
    // fall back to the notice's own wording rather than rendering "as null".
    var masqueradeLogoutLabel = isMasquerading
        ? t('text.masqueradeEducatorLogout', {
            name: (_b = masquerade === null || masquerade === void 0 ? void 0 : masquerade.viewingAsName) !== null && _b !== void 0 ? _b : t('text.masqueradeUnknownUser'),
        })
        : undefined;
    useEffect(function () {
        btnConfig && setBtnData(btnConfig);
        mainConfig && setBtnType(mainConfig[type]);
    }, []);
    var clickHandler = function (id, type, data) {
        onClick && onClick(id, type, data);
    };
    // Auth entry point (headerRight login/logout button). Login opens /login in a
    // centered popup; logout runs /logout in a hidden iframe (see
    // handleLogoutFrame). Either way the auth-dependent UI refreshes IN PLACE via
    // checkAuth — no page reload happens, so the canvas and any unsaved changes
    // are preserved (checkAuth only flips the auth flags the chrome reacts to; it
    // never reloads the activity). IDM can't run signed out, so a logout there
    // redirects the main window to /login.
    //
    // Both flows end the same way: the auth window/frame lands back on this origin
    // at AUTH_POPUP_CALLBACK, which posts to its opener/parent, so we refresh
    // exactly when the flow finishes rather than guessing a duration.
    var refreshAuthUI = function () { return __awaiter(void 0, void 0, void 0, function () {
        var redirect, loggedIn;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isIDM) {
                        redirect = encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
                        window.location.href = "".concat(window.location.origin, "/login?redirect=").concat(redirect);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, checkAuth()];
                case 1:
                    loggedIn = _a.sent();
                    fetchCardDecks(loggedIn);
                    // The saved-work list (folders + share codes) is fetched once and then
                    // cached behind `groupsStore.loaded`, so every consumer of that slice —
                    // `InputWithBtn`'s lazy `if (!groupsLoaded) fetchGroups()`, `SaveWorkModal`'s
                    // folder list — reads the *first* result for the rest of the session. That
                    // first fetch happens on page load, and for a guest `GET /share-codes` is
                    // unauthorized, so the cache holds an empty list. Logging in through the
                    // popup changes the session without reloading the page, which left the
                    // Share panel rendering its action row (`.iwb-actions`) over an empty body.
                    // Refetch here for the same reason the card decks are refetched: both are
                    // auth-dependent. Logout refetches too, which clears the previous user's
                    // codes out of the store instead of leaving them visible.
                    void fetchGroups();
                    return [2 /*return*/];
            }
        });
    }); };
    // Sign the CHROME out immediately, without waiting for the SLO chain.
    //
    // The sign-out is already a fact by the time this runs: the backend clears its
    // own cookie at the START of /logout, so the session on this origin is over as
    // soon as the frame requests it. What the hidden frame is still doing is the
    // IdP's half — and that can take up to AUTH_SETTLE_BACKSTOP_MS, or never
    // report back at all if the IdP refuses to be framed. Waiting for it left the
    // header claiming the user was still signed in for up to five seconds after
    // they confirmed, with nothing on screen to say anything was happening (the
    // popup that used to supply that feedback is deliberately gone — see
    // docs/components/Header.md).
    //
    // This is not a guess that gets corrected later: `refreshAuthUI` still runs
    // when the frame settles and `checkAuth` remains the authority. If the cookie
    // somehow survived, that pass flips the chrome back — the optimistic state is
    // reconciled, never merely trusted.
    //
    // Mirrors checkAuth's own guest branch rather than inventing a state: same
    // four flags, same values (`isAdmin` really is `true` for a guest there).
    // Matomo's audience context is deliberately NOT set here — it is analytics,
    // not chrome, and the reconciling checkAuth sets it once with the confirmed
    // answer instead of reporting the same sign-out twice.
    var applySignedOutUI = function () {
        setIsLoggedIn(false);
        setUsername('');
        setUserId(null);
        setIsAdmin(true);
        setMasquerade(null);
        // The card decks are a static file and both passes request the same guest
        // variant, so refetching here is idempotent and browser-cached.
        fetchCardDecks(false);
        // The share codes are CLEARED, not refetched. `fetchGroups()` would be the
        // obvious mirror of refreshAuthUI and is exactly wrong here: this runs
        // *before* the iframe is appended, so the cookie is still valid, and
        // `GET /share-codes` answers 200 with the previous user's list — putting the
        // codes we are trying to drop straight back into the store and setting
        // `groupsStore.loaded`, which stops any later consumer refetching them.
        //
        // It is also a race with no arbiter: `fetchGroups` has no cancellation or
        // generation token (see groupsStore.ts), so if the frame settles quickly
        // while `/share-codes` is slow, the authenticated response lands *after*
        // the settle pass and the signed-out session keeps the previous user's
        // codes. Clearing the slice outright has neither problem, and the settle
        // pass still runs `fetchGroups` as the authority.
        setSections([]);
    };
    // Does this message carry either completion contract? "sso-login-complete"
    // comes from /auth-popup-complete.html; the older "mlc-auth" shape comes from
    // /login/complete, so a backend still serving that route keeps working.
    var isAuthCompleteMessage = function (event) {
        if (event.origin !== window.location.origin)
            return false;
        var data = event.data;
        return (data === null || data === void 0 ? void 0 : data.type) === 'sso-login-complete' || (data === null || data === void 0 ? void 0 : data.source) === 'mlc-auth';
    };
    // LOGIN — a centered popup. Sign-in is interactive by nature (the hosted form
    // has to be typed into), so this one stays a real window the user can see.
    var handleLoginPopup = function () {
        var w = 480;
        var h = 640;
        var left = window.screenX + Math.max(0, (window.outerWidth - w) / 2);
        var top = window.screenY + Math.max(0, (window.outerHeight - h) / 2);
        // /login takes a ?redirect= target, which is sent to the self-closing
        // callback page (see AUTH_POPUP_CALLBACK).
        //
        // The target MUST be a bare path — never tagged with a marker like
        // "__popup__|". The redirect value becomes the SAML RelayState, which the
        // IdP echoes back to the ACS, and the backend redirects to it verbatim (it
        // only strips its own "__passive__|" prefix). A tagged target therefore
        // survives into the Location header, where it is both unresolvable and
        // *relative*, so the popup lands on /saml/__popup__%7C/… — off the ACS
        // path, 404, and never self-closing. This is exactly the flow the backend's
        // own /sso test page exercises: /login?redirect=<bare callback path>.
        var url = "/login?redirect=".concat(encodeURIComponent(AUTH_POPUP_CALLBACK));
        var popup = window.open("".concat(window.location.origin).concat(url), 'mlc-login', "width=".concat(w, ",height=").concat(h, ",left=").concat(left, ",top=").concat(top, ",resizable,scrollbars"));
        // If the popup was blocked, fall back to refreshing right away.
        if (!popup) {
            void refreshAuthUI();
            return;
        }
        // Refresh the auth-dependent UI once, on whichever signal lands first:
        //   • the completion message the callback page posts just before closing
        //     itself — also the safety net if a browser refuses window.close()
        //   • the popup closing, whether by that page or by the user abandoning
        //     the flow half way through
        var settled = false;
        var finish = function () {
            if (settled)
                return;
            settled = true;
            window.clearInterval(poll);
            window.removeEventListener('message', onMessage);
            void refreshAuthUI();
        };
        var onMessage = function (event) {
            if (!isAuthCompleteMessage(event))
                return;
            popup.close();
            finish();
        };
        window.addEventListener('message', onMessage);
        var poll = window.setInterval(function () {
            if (popup.closed)
                finish();
        }, 500);
    };
    // LOGOUT — a hidden iframe, never a popup.
    //
    // Signing out needs no input from the user, so there is nothing to show. A
    // popup here only ever produced something to stare at: /logout hands the
    // window to the IdP for single-logout, and while it sits on that cross-origin
    // page our popup.close() is a no-op, so the window lingered until the 5s
    // backstop force-closed it. Hiding that popup was tried twice and failed —
    // off-screen positioning and zero dimensions are both undone by the
    // backend-rendered /logout page, which resizes the window on load (see the
    // reverted "busy indicator" attempt, and docs/components/Header.md).
    //
    // An iframe sidesteps the problem instead of fighting it: the SLO chain runs
    // in a frame that has no chrome to resize and that we can remove ourselves,
    // so there is no window to close and nothing for the user to dismiss. The
    // ?redirect= contract is unchanged — the callback page just posts to
    // window.parent instead of window.opener when it is framed.
    var handleLogoutFrame = function () {
        // Local dev "logged-in" mode has no backend to sign out of: /logout is a
        // 404 on the dev server. Refresh in place instead of loading a dead frame,
        // matching checkAuth's own short-circuit (see helper/localLoginMode.ts).
        if (isLocalLoginMode()) {
            void refreshAuthUI();
            return;
        }
        // Sign the chrome out now; the frame below finishes the IdP's half in the
        // background (see applySignedOutUI for why this is a fact, not a guess).
        //
        // IDM is excluded on purpose. There, `refreshAuthUI` responds to a finished
        // logout by navigating the main window to /login — and navigating destroys
        // the iframe. Doing that up front would abort the SLO chain mid-request, so
        // IDM keeps waiting for the frame to settle and only then redirects. It
        // loses nothing by waiting: the whole page is about to be replaced anyway,
        // so there is no stale header for a user to misread.
        if (!isIDM)
            applySignedOutUI();
        var frame = document.createElement('iframe');
        frame.setAttribute('aria-hidden', 'true');
        // Sized to nothing and taken out of flow rather than `display: none`, which
        // some browsers treat as a reason not to load the frame at all.
        frame.style.position = 'absolute';
        frame.style.width = '0';
        frame.style.height = '0';
        frame.style.border = '0';
        // `visibility: hidden` is an ACCESSIBILITY REQUIREMENT here, not styling —
        // do not drop it to debug a framing problem. It is the only thing that keeps
        // the framed IdP document out of the a11y tree and out of the tab order:
        // `tabindex` on the <iframe> element does not reach the document inside it,
        // so without this the `aria-hidden` above would be wrapping focusable
        // cross-origin content (axe `aria-hidden-focus`, WCAG 4.1.2). No `title` for
        // the same reason — `aria-hidden` suppresses it, so it would name nothing.
        frame.style.visibility = 'hidden';
        frame.src = "".concat(window.location.origin, "/logout?redirect=").concat(encodeURIComponent(AUTH_POPUP_CALLBACK));
        // Settle once, on whichever lands first: the callback page's completion
        // message, or the backstop for a chain that never returns to this origin
        // (IdP error, stalled SLO, or an IdP that refuses to be framed via
        // X-Frame-Options / frame-ancestors). The backend clears its own cookie at
        // the start of /logout, so refreshing on the backstop still lands on the
        // correct signed-out UI even when the IdP hop never completes.
        var settled = false;
        var finish = function () {
            if (settled)
                return;
            settled = true;
            window.clearTimeout(backstop);
            window.removeEventListener('message', onMessage);
            frame.remove();
            // IDM logout redirects; otherwise refresh in place.
            void refreshAuthUI();
        };
        var onMessage = function (event) {
            if (!isAuthCompleteMessage(event))
                return;
            finish();
        };
        window.addEventListener('message', onMessage);
        var backstop = window.setTimeout(finish, AUTH_SETTLE_BACKSTOP_MS);
        document.body.appendChild(frame);
    };
    // Filter out hidden buttons.
    //
    // Anything that will not render MUST be excluded here rather than returning
    // null from the map below: `visibleButtons.length` decides which item is last
    // (and so gets `noVisibility` on its trailing <hr>) and feeds `itemCount` for
    // the roving tabindex. A null returned mid-map leaves the count too high, so
    // the real last button keeps a visible dangling divider and arrow-key
    // navigation gains a dead index.
    var visibleButtons = buttonsInfo.filter(function (item) {
        if (!btnData || !btnData[item])
            return false;
        if (hiddenButtons.includes(btnData[item].id))
            return false;
        if (btnData[item].type === 'halfHalfToggleBtn') {
            // Logged-in users ALWAYS see the view/edit toggle, including on a code
            // they don't own. Switching such a code to edit is a supported flow — it
            // raises the save-edits reminder, which points them at Save As so their
            // changes land under a new code. Hiding the toggle from non-owners (the
            // old `!isAdmin` rule) left them with no way to reach that flow at all.
            //
            // Guests keep the narrower rule: they may edit only when there is no
            // share code yet, or the loaded code is one they generated in this tab
            // (tracked in sessionStorage). A guest on someone else's code has no
            // account to save under, so edit mode would be a dead end for them.
            if (!isLoggedIn && !!shareCode && !isOwnShareCode(shareCode))
                return false;
        }
        return true;
    });
    var orientation = align === 'horizontal' ? 'horizontal' : 'vertical';
    // When parent provides roving functions, delegate to parent's toolbar context.
    // Otherwise, manage our own roving tabindex (standalone toolbar).
    var isParentManaged = !!(externalGetTabIndex && externalSetItemRef);
    var ownRoving = useRovingTabIndex({
        itemCount: isParentManaged ? 0 : visibleButtons.length,
        orientation: orientation,
    });
    var setItemRef = isParentManaged
        ? function (i) { return externalSetItemRef(i + rovingStartIndex); }
        : ownRoving.setItemRef;
    var handleKeyDown = isParentManaged ? undefined : ownRoving.handleKeyDown;
    var containerRef = useRef(null);
    // Auto-register roving items from container's direct children.
    // Skips <hr> dividers. This avoids adding extra wrapper divs to the DOM —
    // items like CollapsibleDiv, ColorPicker, ToggleButton render directly
    // without needing an explicit ref prop.
    useEffect(function () {
        if (!containerRef.current)
            return;
        var children = Array.from(containerRef.current.children).filter(function (el) { return el.tagName !== 'HR'; });
        children.forEach(function (child, i) {
            setItemRef(i)(child);
        });
        return function () {
            children.forEach(function (_, i) {
                setItemRef(i)(null);
            });
        };
    }, [visibleButtons.length, btnData, setItemRef]);
    return (_jsx(_Fragment, { children: btnData && (_jsxs("div", __assign({ ref: containerRef, className: "".concat(mainClass, " ").concat(align === 'horizontal' ? 'horizontalBtns' : 'verticalBtns') }, (!isParentManaged && {
            role: 'toolbar',
            'aria-label': ariaLabel ? t(ariaLabel) : undefined,
            'aria-orientation': orientation,
            onKeyDown: handleKeyDown,
        }), { children: [visibleButtons === null || visibleButtons === void 0 ? void 0 : visibleButtons.map(function (item, i) {
                    var _a, _b, _c, _d, _e, _f;
                    var isDisabled = disabledButtons.includes(btnData[item].id);
                    if (btnData[item].type === 'toggleBtn') {
                        return (_jsxs(React.Fragment, { children: [align === 'horizontal' ? (_jsx("div", { className: "toggleParent", children: _jsx(ToggleButton, { initial: btnData[item].id === 'lang'
                                            ? language === 'es'
                                                ? 'ES'
                                                : 'EN'
                                            : undefined, onChange: function (data) {
                                            clickHandler(btnData[item].id, btnData[item].type, data);
                                        }, isParentRelative: isParentRelative, disabled: isDisabled }) })) : (_jsx(ToggleButton, { initial: btnData[item].id === 'lang' ? (language === 'es' ? 'ES' : 'EN') : undefined, onChange: function (data) {
                                        clickHandler(btnData[item].id, btnData[item].type, data);
                                    }, disabled: isDisabled })), _jsx("hr", { "aria-hidden": "true", role: "presentation", className: "verticalHr ".concat(i === visibleButtons.length - 1 && 'noVisibility') })] }, "btn_".concat(i)));
                    }
                    else if (btnData[item].type === 'btn') {
                        if (btnData[item].id === 'save') {
                            return (_jsx(React.Fragment, { children: _jsxs("div", { className: "_btnHolder", children: [_jsx(SaveBtnWithPopup, { btnData: btnData, btnType: btnType, item: item, direction: align === 'horizontal'
                                                ? "".concat(mainClass === 'headerLeft' || mainClass === 'headerRight'
                                                    ? 'bottom'
                                                    : 'top')
                                                : 'right', isParentRelative: isParentRelative, useViewportPosition: useViewportPosition, clickHandler: clickHandler }), _jsx("hr", { "aria-hidden": "true", role: "presentation", className: "verticalHr ".concat(i === visibleButtons.length - 1 && 'noVisibility') })] }) }, "btn_".concat(i)));
                        }
                        else {
                            return (_jsx(React.Fragment, { children: _jsxs("div", { className: "_btnHolder", children: [_jsx(ButtonComponent, { imgSrc: btnData[item].imgSrc, defaultCSS: btnType === null || btnType === void 0 ? void 0 : btnType['style'].defaultCSS, normalCSS: btnType === null || btnType === void 0 ? void 0 : btnType['style'].normalCSS, ariaLabel: btnData[item].ariaLabel, title: btnData[item].title, showToolTip: true, direction: align === 'horizontal'
                                                ? "".concat(mainClass === 'headerLeft' || mainClass === 'headerRight'
                                                    ? 'bottom'
                                                    : 'top')
                                                : 'right', isParentRelative: isParentRelative, useViewportPosition: useViewportPosition, clickHandler: function (e) {
                                                clickHandler(btnData[item].id, btnData[item].type, e);
                                            }, clickActive: btnData === null || btnData === void 0 ? void 0 : btnData[item].activeState, isActive: btnData[item].id === 'keys' ? showEnterKeyModal : false, disabled: isDisabled, type: align === 'vertical' ? buttonStyleType : undefined }), _jsx("hr", { "aria-hidden": "true", role: "presentation", className: "verticalHr ".concat(i === visibleButtons.length - 1 && 'noVisibility') })] }) }, "btn_".concat(i)));
                        }
                    }
                    else if (btnData[item].type === 'collapsibleBtn') {
                        return (_jsxs(React.Fragment, { children: [type === 'footerBtn' ? (_jsxs("div", { style: {
                                        position: 'relative',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }, children: [_jsx(CollapsibleDiv, { elements: btnData[item].elements, mainElement: btnData[item].imgSrc, onSelect: function (data) {
                                                clickHandler(btnData[item].id, btnData[item].type, data);
                                            }, collapsibleContainerCSS: "_btnHolder", openAt: align === 'horizontal' ? 'top' : 'right', direction: align === 'horizontal' ? 'top' : 'right', isParentRelative: collapsible.isRelative, isTooltipRelative: collapsible.isTooltipRelative, isInnerTooltipRelative: collapsible.isInnerTooltipRelative, title: btnData[item].title, ariaLabel: btnData[item].ariaLabel, hr: true, showToolTip: true, type: buttonStyleType, disabled: isDisabled, disabledElements: (_a = collapsibleGuide[btnData[item].id]) === null || _a === void 0 ? void 0 : _a.disabledElements, hiddenElements: (_b = collapsibleGuide[btnData[item].id]) === null || _b === void 0 ? void 0 : _b.hiddenElements, activeElementIds: (_c = collapsibleGuide[btnData[item].id]) === null || _c === void 0 ? void 0 : _c.activeElementIds, parentType: type, useViewportPosition: useViewportPosition }), ' '] })) : (_jsx(CollapsibleDiv, { elements: btnData[item].elements, mainElement: btnData[item].imgSrc, onSelect: function (data) {
                                        clickHandler(btnData[item].id, btnData[item].type, data);
                                    }, collapsibleContainerCSS: "_btnHolder", openAt: align === 'horizontal' ? 'top' : 'right', direction: align === 'horizontal' ? 'top' : 'right', isParentRelative: collapsible.isRelative, isTooltipRelative: collapsible.isTooltipRelative, isInnerTooltipRelative: collapsible.isInnerTooltipRelative, title: btnData[item].title, ariaLabel: btnData[item].ariaLabel, hr: true, showToolTip: true, type: buttonStyleType, disabled: isDisabled, disabledElements: (_d = collapsibleGuide[btnData[item].id]) === null || _d === void 0 ? void 0 : _d.disabledElements, hiddenElements: (_e = collapsibleGuide[btnData[item].id]) === null || _e === void 0 ? void 0 : _e.hiddenElements, activeElementIds: (_f = collapsibleGuide[btnData[item].id]) === null || _f === void 0 ? void 0 : _f.activeElementIds, useViewportPosition: useViewportPosition })), align === 'vertical' &&
                                    /* <hr
                                    className={`verticalHr ${i === visibleButtons.length - 1 && 'noVisibility'}`}
                                  /> */
                                    null] }, "btn_".concat(i)));
                    }
                    else if (btnData[item].type === 'halfHalfToggleBtn') {
                        // Visibility (logged-in / own-share-code) is decided in the
                        // `visibleButtons` filter above, so this branch always renders.
                        return (_jsxs(React.Fragment, { children: [_jsx("div", { className: "_btnHolder", children: _jsx(HalfAndHalfToggleButton, { leftImgSrc: btnData[item].leftImgSrc, rightImgSrc: btnData[item].rightImgSrc, leftTitle: btnData[item].leftTitle, rightTitle: btnData[item].rightTitle, ariaLabel: btnData[item].ariaLabel, 
                                        // Follows the store directly. It used to be forced to
                                        // 'left' for non-admins, which was invisible while the
                                        // toggle was admin-only but would now pin a non-owner's
                                        // toggle to View even after they switched to Edit.
                                        initialValue: viewEditMode === 'view' ? 'left' : 'right', defaultCSS: (btnType === null || btnType === void 0 ? void 0 : btnType['style'].defaultCSS) || 'halfToggleBtn', normalCSS: (btnType === null || btnType === void 0 ? void 0 : btnType['style'].normalCSS) || 'halfToggleBtn', onClick: function (id, type, value) {
                                            clickHandler(btnData[item].id, btnData[item].type, value);
                                        }, id: btnData[item].id, type: btnData[item].type }) }), _jsx("hr", { "aria-hidden": "true", role: "presentation", className: "verticalHr ".concat(i === visibleButtons.length - 1 && 'noVisibility') })] }, "btn_".concat(i)));
                    }
                    else if (btnData[item].type === 'colorPlate') {
                        return type === 'footerBtn' ? (_jsx("div", { style: {
                                position: 'relative',
                                // zIndex: 10,
                                display: 'flex',
                                alignItems: 'center',
                            }, children: _jsx(ColorPicker, { isPositionRelative: type === 'footerBtn', openAt: 'top', collapsibleContainerCSS: "colorPicker _btnHolder", hrVisible: type !== 'footerBtn', tooltipDirection: type === 'footerBtn' ? 'right' : undefined, parentType: type, useViewportPosition: useViewportPosition, disabled: isDisabled }, "btn_".concat(i)) })) : (_jsx(ColorPicker, { isPositionRelative: type === 'footerBtn', collapsibleContainerCSS: "_btnHolder", hrVisible: type !== 'footerBtn', tooltipDirection: type === 'footerBtn' ? 'right' : undefined, parentType: type, useViewportPosition: useViewportPosition, disabled: isDisabled }, "btn_".concat(i)));
                    }
                }), mainClass === 'headerRight' && (_jsxs(React.Fragment, { children: [_jsx("hr", { "aria-hidden": "true", role: "presentation", className: "verticalHr" }), _jsx("div", { className: "_btnHolder", children: _jsx(ButtonComponent, { imgSrc: isLoggedIn
                                    ? isMasquerading
                                        ? {
                                            normal: './assets/images/icons/logoutMasqueradeN.svg',
                                            hover: './assets/images/icons/logoutMasqueradeH.svg',
                                        }
                                        : {
                                            normal: './assets/images/icons/logoutN.svg',
                                            hover: './assets/images/icons/logoutH.svg',
                                        }
                                    : {
                                        normal: './assets/images/icons/loginN.svg',
                                        hover: './assets/images/icons/loginH.svg',
                                    }, defaultCSS: btnType === null || btnType === void 0 ? void 0 : btnType['style'].defaultCSS, normalCSS: btnType === null || btnType === void 0 ? void 0 : btnType['style'].normalCSS, 
                                // During a masquerade both the tooltip and the accessible
                                // name name the impersonated account, so the disclosure
                                // survives the notice being dismissed. They must stay the
                                // same string: a tooltip that says more than the accessible
                                // name hides the disclosure from exactly the users who
                                // cannot see the tooltip. The `*Translated` props are
                                // required rather than stylistic — the finished sentence
                                // contains a name and a `.`, and `t()` would read those as
                                // key separators.
                                ariaLabel: isLoggedIn ? 'text.educatorLogout' : 'text.educatorLogin', ariaLabelTranslated: masqueradeLogoutLabel, title: isLoggedIn ? 'text.educatorLogout' : 'text.educatorLogin', titleTranslated: masqueradeLogoutLabel, showToolTip: true, 
                                // Rightmost header button: open the tooltip toward the left
                                // (`bottomLeft`) so it isn't clipped by the viewport edge.
                                direction: "bottomLeft", isParentRelative: isParentRelative, useViewportPosition: useViewportPosition, clickHandler: function () {
                                    if (isLoggedIn) {
                                        setShowLogoutConfirm(true);
                                        return;
                                    }
                                    handleLoginPopup();
                                } }) }), showLogoutConfirm && (_jsx(Popup, { isOpen: true, onClose: function () { return setShowLogoutConfirm(false); }, className: "className-eraserPopup", ariaLabel: t('text.logoutConfirm'), children: _jsx("div", { className: "eraserWrapper", children: _jsxs("div", { className: "container", children: [_jsxs("div", { className: "upperPart", children: [_jsx("div", { className: "title", children: t('text.logoutConfirm') }), _jsx("hr", { className: "popupHr", "aria-hidden": "true" }), _jsxs("div", { className: "btnContainer", children: [_jsx(ButtonComponent, { type: "textType1", text: t('text.cancel'), defaultCSS: "customBtn", normalCSS: "btn", clickHandler: function () { return setShowLogoutConfirm(false); }, noAudio: true }), _jsx(ButtonComponent, { type: "textType1", text: t('text.logout'), defaultCSS: "customBtn", normalCSS: "btn", clickHandler: function () {
                                                                setShowLogoutConfirm(false);
                                                                handleLogoutFrame();
                                                            }, noAudio: true })] })] }), _jsx("div", { className: "footerImageHolder", style: {
                                                backgroundImage: 'url(./assets/images/shareColourPatches.svg)',
                                            } })] }) }) }))] }))] }))) }));
};
export default ButtonGroup;
